//core
import { createSelector } from "@reduxjs/toolkit";

//store
import { RootState } from "../../index";

// state
const subAffDealsV2Selector = (state: RootState) => state.admin.subAffDealsV2;

const subAffDealsV2ListSelector = (state: RootState) => state.admin.subAffDealsV2.list;
const subAffDealsV2ListDataSelector = (state: RootState) => state.admin.subAffDealsV2.list.data;
const subAffDealsV2ListErrorSelector = (state: RootState) => state.admin.subAffDealsV2.list.error;
const subAffDealsV2ListFetchingSelector = (state: RootState) => state.admin.subAffDealsV2.list.isFetching;

//selectors
export const selectAdmConditions = createSelector(subAffDealsV2Selector, (conditions) => conditions);

export const selectList = createSelector(subAffDealsV2ListSelector, (list) => list);
export const selectListData = createSelector(subAffDealsV2ListDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'id') {
        return { ...item, type: 'string' };
      }
      if (item.name === 'title') {
        return { ...item, type: 'mediumString' };
      }
      if (item.name === 'description') {
        return { ...item, type: 'mediumString' };
      }
			if (item.name === 'createdBy') {
        return { ...item, type: 'mediumString' };
      }
			if (item.name === 'updatedBy') {
        return { ...item, type: 'mediumString' };
      }
			if (item.name === 'createdAt') {
        return { ...item, type: 'fulldatetime' };
      }

      return item;
    });

    return { ...data, columns: columns };
  } else {
    return data;
  }
});
export const selectListDataColumnsSort = createSelector(subAffDealsV2ListDataSelector, (data) => {
  return data?.columns.filter((el) => el.sort === true)
});
export const selectListError = createSelector(subAffDealsV2ListErrorSelector, (error) => error);
export const selectListIsFetching = createSelector(subAffDealsV2ListFetchingSelector, (isFetching) => isFetching);

//delete
const deletesSubAffDealDataSelector = (state: RootState) => state.admin.subAffDealsV2.deleteCondition.data;
const deletesSubAffDealErrorSelector = (state: RootState) => state.admin.subAffDealsV2.deleteCondition.error;
const deletesSubAffDealFetchingSelector = (state: RootState) => state.admin.subAffDealsV2.deleteCondition.isFetching;

export const selectDeleteConditionData = createSelector(deletesSubAffDealDataSelector, (data) => data);
export const selectDeleteConditionError = createSelector(deletesSubAffDealErrorSelector, (error) => error);
export const selectDeleteConditionIsFetching = createSelector(deletesSubAffDealFetchingSelector, (isFetching) => isFetching);

//constants
const subAffDealConstantsDataSelector = (state: RootState) => state.admin.subAffDealsV2.constants.data;
const subAffDealConstantsErrorSelector = (state: RootState) => state.admin.subAffDealsV2.constants.error;
const subAffDealConstantsFetchingSelector = (state: RootState) => state.admin.subAffDealsV2.constants.isFetching;

export const selectConditionConstantsData = createSelector(subAffDealConstantsDataSelector, (data) => data);
export const selectConditionConstantsError = createSelector(subAffDealConstantsErrorSelector, (error) => error);
export const selectConditionConstantsIsFetching = createSelector(subAffDealConstantsFetchingSelector, (isFetching) => isFetching);

//createCondition
const createSubAffDealDataSelector = (state: RootState) => state.admin.subAffDealsV2.createCondition.data;
const createSubAffDealErrorSelector = (state: RootState) => state.admin.subAffDealsV2.createCondition.error;
const createSubAffDealFetchingSelector = (state: RootState) => state.admin.subAffDealsV2.createCondition.isFetching;

export const selectCreateConditionData = createSelector(createSubAffDealDataSelector, (data) => data);
export const selectCreateConditionError = createSelector(createSubAffDealErrorSelector, (error) => error);
export const selectCreateConditionIsFetching = createSelector(createSubAffDealFetchingSelector, (isFetching) => isFetching);

//viewCondition
const viewSubAffDealDataSelector = (state: RootState) => state.admin.subAffDealsV2.viewCondition.data;
const viewSubAffDealErrorSelector = (state: RootState) => state.admin.subAffDealsV2.viewCondition.error;
const viewSubAffDealFetchingSelector = (state: RootState) => state.admin.subAffDealsV2.viewCondition.isFetching;

export const selectViewConditionData = createSelector(viewSubAffDealDataSelector, (data) => data);
export const selectViewConditionError = createSelector(viewSubAffDealErrorSelector, (error) => error);
export const selectViewConditionIsFetching = createSelector(viewSubAffDealFetchingSelector, (isFetching) => isFetching);

//editCondition
const editSubAffDealDataSelector = (state: RootState) => state.admin.subAffDealsV2.editCondition.data;
const editSubAffDealErrorSelector = (state: RootState) => state.admin.subAffDealsV2.editCondition.error;
const editSubAffDealFetchingSelector = (state: RootState) => state.admin.subAffDealsV2.editCondition.isFetching;

export const selectEditConditionData = createSelector(editSubAffDealDataSelector, (data) => data);
export const selectEditConditionError = createSelector(editSubAffDealErrorSelector, (error) => error);
export const selectEditConditionIsFetching = createSelector(editSubAffDealFetchingSelector, (isFetching) => isFetching);

//Creator Filter
const filterSubAffDealCreatorDataSelector = (state: RootState) => state.admin.subAffDealsV2.filterCreator.data;
const filterSubAffDealCreatorErrorSelector = (state: RootState) => state.admin.subAffDealsV2.filterCreator.error;
const filterSubAffDealCreatorFetchingSelector = (state: RootState) => state.admin.subAffDealsV2.filterCreator.isFetching;

export const selectFilterSubAffDealCreatorData = createSelector(filterSubAffDealCreatorDataSelector, (data) => data);
export const selectFilterSubAffDealCreatorError = createSelector(filterSubAffDealCreatorErrorSelector, (error) => error);
export const selectFilterSubAffDealCreatorIsFetching = createSelector(filterSubAffDealCreatorFetchingSelector, (isFetching) => isFetching);

//Deal on aff profile
const dealDataSelector = (state: RootState) => state.admin.subAffDealsV2.deal.data;
const dealErrorSelector = (state: RootState) => state.admin.subAffDealsV2.deal.error;
const dealFetchingSelector = (state: RootState) => state.admin.subAffDealsV2.deal.isFetching;

export const selectDealData = createSelector(dealDataSelector, (data) => data);
export const selectDealError = createSelector(dealErrorSelector, (error) => error);
export const selectDealIsFetching = createSelector(dealFetchingSelector, (isFetching) => isFetching);

//Deal levels on aff profile
const dealLevelsDataSelector = (state: RootState) => state.admin.subAffDealsV2.dealLevels.data;
const dealLevelsErrorSelector = (state: RootState) => state.admin.subAffDealsV2.dealLevels.error;
const dealLevelsFetchingSelector = (state: RootState) => state.admin.subAffDealsV2.dealLevels.isFetching;

export const selectDealLevelsData = createSelector(dealLevelsDataSelector, (data) => data);
export const selectDealLevelsError = createSelector(dealLevelsErrorSelector, (error) => error);
export const selectDealLevelsIsFetching = createSelector(dealLevelsFetchingSelector, (isFetching) => isFetching);

//Assignable deals
const assignableDealListDataSelector = (state: RootState) => state.admin.subAffDealsV2.dealList.data;
const assignableDealListErrorSelector = (state: RootState) => state.admin.subAffDealsV2.dealList.error;
const assignableDealListFetchingSelector = (state: RootState) => state.admin.subAffDealsV2.dealList.isFetching;

export const selectAssignableDealListData = createSelector(assignableDealListDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'id') {
        return { ...item, type: 'select_sub_aff_deal_row' };
      }

      if (item.name === 'createdBy') {
        return { ...item, name: 'createdByName' };
      }

      if (item.name === 'title') {
        return { ...item, type: 'shortString' };
      }

      if (item.name === 'description') {
        return { ...item, type: 'mediumString' };
      }

      return item;
    });

    return { ...data, columns: columns };
  } else {
    return data;
  }
});
export const selectAssignableDealListError = createSelector(assignableDealListErrorSelector, (error) => error);
export const selectAssignableDealListIsFetching = createSelector(assignableDealListFetchingSelector, (isFetching) => isFetching);

//Update Assignable deals
const updateAssignableDealDataSelector = (state: RootState) => state.admin.subAffDealsV2.updateAssignableDeal.data;
const updateAssignableDealErrorSelector = (state: RootState) => state.admin.subAffDealsV2.updateAssignableDeal.error;
const updateAssignableDealFetchingSelector = (state: RootState) => state.admin.subAffDealsV2.updateAssignableDeal.isFetching;

export const selectUpdateAssignableDealData = createSelector(updateAssignableDealDataSelector, (data) => data);
export const selectUpdateAssignableDealError = createSelector(updateAssignableDealErrorSelector, (error) => error);
export const selectUpdateAssignableDealIsFetching = createSelector(updateAssignableDealFetchingSelector, (isFetching) => isFetching);